/**
 * 管理后台用户接口
 * 管理后台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import JwClazzVo from './JwClazzVo';
import TextBookBaseVo from './TextBookBaseVo';




  /**
   * The RedeemTextBookVo model module.
   * @module account_mgt/model/RedeemTextBookVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>RedeemTextBookVo</code>.
   * @alias module:account_mgt/model/RedeemTextBookVo
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>RedeemTextBookVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account_mgt/model/RedeemTextBookVo} obj Optional instance to populate.
   * @return {module:account_mgt/model/RedeemTextBookVo} The populated <code>RedeemTextBookVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'textbook')) {
        obj['textbook'] = TextBookBaseVo.constructFromObject(data['textbook']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'redeemTime')) {
        obj['redeemTime'] = ApiClient.convertToType(data['redeemTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwClazz')) {
        obj['jwClazz'] = JwClazzVo.constructFromObject(data['jwClazz']);
      }
    }
    return obj;
  }

  /**
   * @member {module:account_mgt/model/TextBookBaseVo} textbook
   */
  exports.prototype['textbook'] = undefined;
  /**
   * 兑换时间
   * @member {Date} redeemTime
   */
  exports.prototype['redeemTime'] = undefined;
  /**
   * 发放班级
   * @member {module:account_mgt/model/JwClazzVo} jwClazz
   */
  exports.prototype['jwClazz'] = undefined;



  export default exports;
;


